import { Search, X } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {useState} from "react";

interface SearchQueryProps {
    onChange: (value: string) => void
    placeholder: string
}

export const SearchQuery = ({
    onChange,
    placeholder
}: SearchQueryProps) => {
    const [text, setText] = useState('')
  return (
    <div className="relative min-w-[240px] flex-1">
      <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        placeholder={placeholder}
        className="bg-white pl-9 pr-4"
        value={text}
        onChange={(e) => {
            onChange(e.target.value)
            setText(e.target.value)
        }}
      />
      {text && (
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-1 top-1.5 h-7 w-7"
          onClick={() => {
              setText('')
              onChange('')
          }}
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}
